module.exports = __webpack_public_path__ + "static/media/V2.a6d68d3e.mp4";